export default "__VITE_ASSET__nlMwHFXU__"